<template>
  <div class="brightness" :style="'opacity: '+brightness"></div>
</template>
<script>
export default {
  name: "Brightness",
  data() {
    return {}
  },
  props: {
    brightness: {
      default: 0
    }
  }
}
</script>
<style>
.brightness{
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  /* V-dialog has 202 z-index (at least in latest production) */
  z-index:1000;
  pointer-events: none;
  background-color: rgba(0,0,0,1);
}
</style>



// WEBPACK FOOTER //
// src/partials/Brightness.vue